import $ from "jquery";
$(".search-toggle").click(function () {
  $(".menu-toggle, .nav-menu").removeClass("active");
  $(".search-toggle, .header-search, .menu-item.search").toggleClass("active");
  $("header .search-field").focus();
});
